import React from "react"

export default () => (
  <svg width="24px" height="24px" viewBox="0 0 24 24">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <polyline stroke="#FFFFFF" strokeWidth="3" points="2 12 9 19 23 5" />
    </g>
  </svg>
)
